/* !!! */
/* grey OUTDATED, do not use */
/* purple OUTDATED, do not use */
/* green OUTDATED, do not use */

export var colorNames = ['black', 'core-purple', 'light-grey', 'white', 'black-purple', 'dark-blue', 'dark-core-purple', 'dark-green', 'dark-grey', 'dark-pink', 'dark-purple', 'dark-red', 'dark-teal', 'deep-purple', 'light-core-purple', 'light-green', 'orange', 'pink', 'red', 'darkest-grey', 'border-grey', 'grey', 'purple', 'green', 'none'];